module.exports = __webpack_public_path__ + "img/select-arrow.78fb06ea.svg";